import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RelatorioDTO } from '../dtos/relatorio-dto';
import { AbstractServicePrivate } from '../service/abstract.service.private';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractRelatorioService extends AbstractServicePrivate {

  protected getBaseUrlPrivate(): string {

    return environment.url + '/private/relatorios/';
  }

  gerarRelatorioDeDisponibilidadeDeVagas(relatorioDTO: RelatorioDTO): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPrivate()}/disponibilidadeDeVagas`, relatorioDTO, httpOptions);
  }

  gerarRelatorioDeMarcacoesInternas(relatorioDTO: RelatorioDTO): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPrivate()}/marcacoesInternas`, relatorioDTO, httpOptions);
  }

  gerarRelatorioDeMarcacoes(relatorioDTO: RelatorioDTO): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPrivate()}/marcacoes`, relatorioDTO, httpOptions);
  }

  gerarRelatorioDeDadosDoAgendamento(relatorioDTO: RelatorioDTO): any {

    const httpOptions = {
      responseType: 'arraybuffer' as 'json'
    };

    return this.http.post(`${this.getBaseUrlPrivate()}/dadosAgendamento`, relatorioDTO, httpOptions);
  }
}
